import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate,useLocation  } from 'react-router-dom';
import { AuthProvider, useAuth } from './components/PatientHistory/AuthContext';
// Import all your components (ensure paths and filenames are correct)
import Footer from './components/Footer/Footer';
import About from './components/About/About';
import Layout from './components/Layout/Layout';
import Services from './components/Services/Services';
import Appointments from './components/Appointments/Appointments';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';
import Booking from './components/Booking/Booking';
import CheckOut from './components/CheckOut/CheckOut';
import DoctorProfile from './components/DoctorProfile/DoctorProfile';
import Gallery from './components/Gallery/Gallery';
import Videos from './components/Videos/Videos';
import Login from './admin/component/Login/Login';
import TermsCondition from './components/TermCondition/TermCondition';
import Availabletest from './components/Availabletest/Availabletest';
import Urology from './components/Clinic-Specialities/Urology';
import Neurology from './components/Clinic-Specialities/Neurology';
import Cardiology from './components/Clinic-Specialities/Cardiology';
import Orthopedic from './components/Clinic-Specialities/Orthopedic';
import Hepatology from './components/Clinic-Specialities/Hepatology';
import Dental from './components/Clinic-Specialities/Dental';
import Emergency from './components/Clinic-Specialities/Emergency';
import Laparoscopy from './components/Clinic-Specialities/Laparoscopy';
import ICU from './components/Clinic-Specialities/ICU';
import Women from './components/Clinic-Specialities/Women';
import ENT from './components/Clinic-Specialities/ENT '; 
import Psychiatry from './components/Clinic-Specialities/Psychiatry';
import Physio from './components/Clinic-Specialities/Physio';
import Oncology from './components/Clinic-Specialities/OnCology';
import Pediatric from './components/Clinic-Specialities/Pediatric';
import Skin from './components/Clinic-Specialities/Skin';
import Internal from './components/Clinic-Specialities/Internal';
import Facilities from './components/Facilities/Facilities';
import Blog from './components/Blog/Blog';
import Tester from './admin/component/Tester/Tester';
import Transaction from './admin/component/Transaction/Transaction';
import Appoint from './admin/component/Appoint/Appoint';
import Dashboard from './admin/component/Dashboard/Dashboard';
import DoctorList from './admin/component/DoctorList/DoctorList';
import Patients from './admin/component/Patients/Patients';
import AdminSidebar from './admin/component/Adminsidebar/AdminSidebar';
import Addblogs from './admin/component/AddBlogs/Addblogs';
import AddGallery from './admin/component/AddGallery/AddGallery';
import AddCarousel from './admin/component/Addcarousel/Addcarousel';
import AddVideos from './admin/component/Addvideo/Addvideo';
import PatientLogin from './components/PatientLogin/PatientLogin';
import Leadership from './components/Leadership/Leadership';
import Contact from "./components/Contact/Contact";
import AddDoctor from "./admin/component/AddDoctor/AddDoctor";
import ChangePassword from "./admin/component/ChangePassword/Changepassword"
import { getToken } from './admin/component/Login/Authutils';
import Anaesthesia from './components/Clinic-Specialities/Anaesthesia';
import ObGynInfertility from './components/Clinic-Specialities/OB-GYN';
import Radiology from './components/Clinic-Specialities/Radiology';
import NICU from './components/Clinic-Specialities/NICU';
import SICU from './components/Clinic-Specialities/SICU';
import Pharmacy from './components/Clinic-Specialities/pharmacy';
import Razorpay from './components/Razorpay/Razorpay';
import BookingSuccess from './components/BookingSuccess/BookingSuccess';
import BookingFailed from './components/BookingFailed/BookingFailed';
import Feedback from './admin/component/Feedback/Feedback';
import ListDoctor from './components/ListDoctor/ListDoctor';
import Reviews from './components/reviews/Reviews';
import BlogDetail from './admin/component/BlogDetails/Blogdetails';
import VideoGallery from './components/VideoGallery/VideoGallery';
import CareerPage from './components/Carrer/Carrer';
import AdminPanel from './admin/component/Addjob/Addjob';
import ApplicationsDashboard from './admin/component/Viewapplication/Viewapplication';
import AuthForm from './components/PatientHistory/AuthForm';
import AppointmentHistory from './components/PatientHistory/AppointmentHistory';
import LoadingSpinner from './components/PatientHistory/LoadingSpinner';
import NewAddDoctor from './admin/component/Addnewdoc/AddNewDoc';

const App = () => {

  const [token, setToken] = useState(localStorage.getItem("token"));
  const [expirationTime, setExpirationTime] = useState(
    parseInt(localStorage.getItem("expirationTime")) || null
  );

  const handleLogin = (newToken) => {
    const expiration = Date.now() + 120000; // 2 minutes expiration time
    localStorage.setItem("token", newToken);
    localStorage.setItem("expirationTime", expiration);
    setToken(newToken);
    setExpirationTime(expiration);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("expirationTime");
    setToken(null);
    setExpirationTime(null);
  
    // Redirect to login page
    window.location.href = "/login";
  };

  useEffect(() => {
    if (token && expirationTime) {
      const timeout = setTimeout(() => {
        handleLogout(); // Clear token when expired
      }, expirationTime - Date.now());

      return () => clearTimeout(timeout);
    }
  }, [token, expirationTime]);

  const PrivateRoute = ({ element }) => {
    const token = getToken();
     const location = useLocation();
    const isExpired = expirationTime && Date.now() > expirationTime;
    if (isExpired) {
      handleLogout(); // Clear token when expired
      return <Navigate to="/login" />;
    }
    return token ? element : <Navigate to="/login" state={{ from: location }} />;
  };

  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Public route for login */}
          <Route path="/login" element={<Login setToken={handleLogin} />} />

          {/* Protected Routes */}
          <Route  path="/adddoctorprofile"  element={<PrivateRoute element={<AddDoctor onLogout={handleLogout} />} />}  />
          <Route  path="/feedback"  element={<PrivateRoute element={<Feedback onLogout={handleLogout} />} />} />
           <Route  path="/changepassword"  element={<PrivateRoute element={<ChangePassword onLogout={handleLogout} />} />} />
          <Route  path="/dash"  element={<PrivateRoute element={<Dashboard onLogout={handleLogout} />} />} />
          <Route path="/booking-success/:appointmentId" element={<BookingSuccess /> }/>
        <Route path="/booking-failed/:appointmentId"element={   <BookingFailed />}/>
          {/* Other public routes */}
          <Route path="/" element={<Layout />} />
          <Route path="/about" element={<About />} />
          <Route path='/services' element={<Services />} />
          <Route path='/appointments' element={<Appointments />} />
          <Route path='/privacypolicy' element={<PrivacyPolicy />} />
          <Route path='/booking/:doctorId' element={<Booking />} />
          <Route path='/checkout' element={<CheckOut />} />
          <Route path='/doctor-profile/:doctorId' element={<DoctorProfile />} />
          <Route path='/gallery' element={<Gallery />} />
          <Route path='/videos' element={<Videos />} />
          <Route path="/terms" element={<TermsCondition />} />
          <Route path="/test" element={<Availabletest />} />
          <Route path="/urology" element={<Urology />} />
          <Route path="/neurology" element={<Neurology />} />
          {/* <Route path="/cardiology" element={<Cardiology />} /> */}
          {/* <Route path="/dental" element={<Dental />} /> */}
          <Route path="/orthopedic" element={<Orthopedic />} />
          {/* <Route path="/hepatology" element={<Hepatology />} /> */}
          <Route path="/emergency" element={<Emergency />} />
          <Route path="/lap" element={<Laparoscopy />} />
          <Route path="/icu" element={<ICU />} />
          <Route path="/women" element={<Women />} />
          <Route path="/ent" element={<ENT />} />
          {/* <Route path="/psy" element={<Psychiatry />} /> */}
          {/* <Route path="/phy" element={<Physio />} /> */}
          <Route path="/onco" element={<Oncology />} />
          <Route path="/ped" element={<Pediatric />} />
          {/* <Route path="/skin" element={<Skin />} /> */}
          <Route path="/internal" element={<Internal />} />
          <Route path="/facilities" element={<Facilities />} />
          <Route path="/blogs" element={<Blog />} />
          <Route path="/anaesthesia" element={<Anaesthesia />} />
          <Route path="/OB-GYN" element={<ObGynInfertility />} />
          <Route path="/radiology" element={<Radiology />} />
          <Route path="/NICU" element={<NICU />} />
          <Route path="/SICU" element={<SICU />} />
          <Route path="/pharmacy" element={<Pharmacy />} />
          <Route path="/razorpay" element={<Razorpay />} />

          
          {/* Admin related routes */}
          <Route path="/tester" element={<PrivateRoute element={<Tester onLogout={handleLogout} />} />} />
          <Route path="/patient" element={<PrivateRoute element={<Patients onLogout={handleLogout} />} />} />
          <Route path="/doctor" element={<PrivateRoute element={<DoctorList onLogout={handleLogout} />} />} />
          <Route path="/tran" element={<PrivateRoute element={<Transaction onLogout={handleLogout} />} />} />
          <Route path="/appoint" element={<PrivateRoute element={<Appoint onLogout={handleLogout} />} />} />
          <Route path="/adminsidebar" element={<PrivateRoute element={<AdminSidebar onLogout={handleLogout} />} />} />
          <Route path="/addblogs" element={<PrivateRoute element={<Addblogs onLogout={handleLogout} />} />} />
          <Route path="/addgallery" element={<PrivateRoute element={<AddGallery onLogout={handleLogout} />} />} />
          <Route path="/addcarousel" element={<PrivateRoute element={<AddCarousel onLogout={handleLogout} />} />} />
          <Route path="/addvideos" element={<PrivateRoute element={<AddVideos onLogout={handleLogout} />} />} />
 <Route path="/viewjob" element={<PrivateRoute element={<ApplicationsDashboard onLogout={handleLogout} />} />} />
 <Route path="/addjobname" element={<PrivateRoute element={<AdminPanel onLogout={handleLogout} />} />} />

          <Route path="/patientlogin/:doctorId" element={<PatientLogin />} />
          <Route path="/leadership" element={<Leadership />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/listdoctor" element={<ListDoctor />} />
          <Route path="/revie" element={<Reviews />} />
             <Route path="/blog/:blogId" element={<BlogDetail />} />
    <Route path="/videogallery" element={<VideoGallery />} />
    <Route path="/carrer" element={<CareerPage />} />
 <Route path="/patientlogin" element={<AuthForm />} />
 <Route path="/history" element={<AppointmentHistory />} />
 <Route path="/adddoctor" element={<NewAddDoctor />} />

    
  


        </Routes>
      </div>
    </Router>
  );
}

export default App;
